<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="ts-space-y-2">
        <div class="row">
          <div class="col-md-12">
            <label class="ts-text-xs required">{{ $t('expenseCategory.expenseCatCode') }}</label>
            <input
              v-model="model.exp_cat_code"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': errors.has('exp_cat_code') }"
            />
            <div
              class="invalid-feedback ts-text-xs"
              v-if="errors.has('exp_cat_code')"
            >{{ errors.first('exp_cat_code') }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="required ts-text-xs">{{ $t('expenseCategory.expenseCategoryName') }}</label>
            <input
              v-model="model.exp_category"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': errors.has('exp_category') }"
            />
            <div
              class="invalid-feedback ts-text-xs"
              v-if="errors.has('exp_category')"
            >{{ errors.first('exp_category') }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="ts-text-xs">{{ $t('expenseCategory.expenseCategoryDescription') }}</label>
            <textarea
              v-model="model.exp_cat_desc" 
              rows="3" 
              class="form-control"
            ></textarea>
            <div
              class="invalid-feedback ts-text-xs"
              v-if="errors.has('exp_cat_desc')"
            >{{ errors.first('exp_cat_desc') }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 ts-mt-3 text-right">
            <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
              {{
              $t('cancel')
              }}
            </ts-button>
            <ts-button
              v-if="!isUpdate"
              color="primary"
              @click.prevent="onSave"
              :waiting="waiting"
            >{{ $t('save') }}</ts-button>
            <ts-button
              v-if="isUpdate"
              color="primary"
              @click.prevent="onUpdate"
              :waiting="waiting"
            >{{ $t('update') }}</ts-button>
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  name: 'expenseCategoryForm',
  data() {
    return {
      errors: new Errors(),
      loading: false,
      waiting: false,
      waiting_new: false,
      model: {
        exp_cat_id: 0,
        exp_cat_code: null,
        exp_category: null,
        exp_cat_desc: null
      }
    }
  },
  async created() {
    await this.setEditData()
  },
  computed: {
    ...mapState('expense/expenseCategory', ['edit_data']),
    isUpdate() {
      return !_.isEmpty(this.edit_data)
    }
  },
  methods: {
    onSave() {
      this.waiting = true
      this.$store
        .dispatch('expense/expenseCategory/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onUpdate() {
      this.waiting = true
      this.$store
        .dispatch('expense/expenseCategory/update', {
          id: this.model.exp_cat_id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.model.exp_cat_id = this.edit_data.exp_cat_id
        this.model.exp_cat_code = this.edit_data.exp_cat_code
        this.model.exp_category = this.edit_data.exp_category
        this.model.exp_cat_desc = this.edit_data.exp_cat_desc
      }
    }
  }
}
</script>
